import {$http} from '@/utils/https';
import Vue from 'vue';
import _ from 'lodash';
import {
    GET_ORDERS_LIST_LOADING,
    SET_ORDERS_LIST,
    FRESH_ORDER_LIST,
    CANCEL_ORDER_LOADING,
    POPUP_ORDER
} from '../mutation-types';

import {
    GET_ORDERS_LIST,
    CANCEL_ORDER
} from '../action-types';


const state = {
    list: null,
    loading: false,
    loadingCancel: false,
    popupOrder: {
        show: false,
        id: ''
    }
};

const getters = {
    list: state => state.list,
    loadingCancel: state => state.loadingCancel,
    popupOrder: state => state.popupOrder,
    loading: state => state.loading,
};

const actions = {
    [GET_ORDERS_LIST]: async ({commit}) => {
        commit(GET_ORDERS_LIST_LOADING, true);
        try {
            const response = await $http.get('v1/order/active?include=products');
            commit(SET_ORDERS_LIST, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(GET_ORDERS_LIST_LOADING, false);
        }
    },
    [CANCEL_ORDER]: async ({commit}, payload) => {
        commit(CANCEL_ORDER_LOADING, true);
        try {
            const response = await $http.get(`v1/order/${state.popupOrder.id}/cancel`);
            commit(FRESH_ORDER_LIST, state.popupOrder);
        } catch (e) {
            throw e;
        } finally {
            commit(CANCEL_ORDER_LOADING, false);
        }
    },
};

const mutations = {
    [SET_ORDERS_LIST](state, list) {
        let arr = [];
        if(list.length !== 0){
            list.forEach((e, i) => {
                let isHasItem = false;
                const index = _.findIndex(arr, t => t.group === e.group);
                if(index >= 0){
                    isHasItem = true;
                }
                if(!isHasItem){
                    arr.unshift(e)
                }else{
                    const index2 = _.findIndex(arr, t => t.group === e.group);
                    arr[index2].products.data.push(...e.products.data)
                }
            });

            arr.map(e => {
                e.date = e.created_at;
                e.amount = 0;
                e.days = 0;
                e.loading = false;
                e.products.data.map(t => {
                    e.days = e.days + t.days;
                    t.img = t.img ? t.img : require('@/assets/img/default-img.jpg')
                    t.amount = Math.round((t.days * t.price_rent * t.count) * 100) / 100;
                    e.amount = t.amount + e.amount;

                });
            });
            state.list = arr;
        }else{
            state.list = [];
        }
    },
    [GET_ORDERS_LIST_LOADING](state, status) {
        state.loading = status;
    },
    [FRESH_ORDER_LIST](state, params) {
        const index = _.findIndex(state.list, e => e.id === params.id);
        Vue.delete(state.list, index);
    },
    [CANCEL_ORDER_LOADING](state, status) {
        state.loadingCancel = status;
    },
    [POPUP_ORDER](state, param) {
       state.popupOrder = param;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
